const getters = {
  getCountries: state => state.countries,
  getTimeZones: state => state.timeZones
}

const actions = {
  setCountries ({ commit }, data) {
    commit('setCountries', data)
  },
  setTimeZones ({ commit }, data) {
    commit('setTimeZones', data)
  }
}

const mutations = {
  setCountries (state, data) {
    state.countries = data
  },
  setTimeZones (state, data) {
    state.timeZones = data
  }
}

const state = {
  countries: [],
  timeZones: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
